import { render, staticRenderFns } from "./ReleasedTable.vue?vue&type=template&id=728ce6a4&"
import script from "./ReleasedTable.vue?vue&type=script&lang=js&"
export * from "./ReleasedTable.vue?vue&type=script&lang=js&"
import style0 from "./ReleasedTable.vue?vue&type=style&index=0&id=728ce6a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports